type MergeTagField = {
    id: string;
    label: string;
    fallback?: string;
    entityType: 'Contacts' | 'Accounts';
};

const hasCustomFieldMergeTagsFF =
    typeof NutClientConfig !== 'undefined' && NutClientConfig.hasCustomFieldMergeTagsFF;

export const FIRST_NAME_MERGE_TAG_FIELD: MergeTagField = {
    id: 'firstName',
    label: 'First name',
    fallback: hasCustomFieldMergeTagsFF ? 'Friend' : undefined,
    entityType: 'Contacts',
};
export const LAST_NAME_MERGE_TAG_FIELD: MergeTagField = {
    id: 'lastName',
    label: 'Last name',
    fallback: hasCustomFieldMergeTagsFF ? 'Last name' : undefined,
    entityType: 'Contacts',
};
export const COMPANY_NAME_MERGE_TAG_FIELD: MergeTagField = {
    id: 'companyName',
    label: 'Company name',
    fallback: hasCustomFieldMergeTagsFF ? 'your company' : undefined,
    entityType: 'Accounts',
};

export const NAMED_MERGE_TAG_FIELDS: MergeTagField[] = [
    FIRST_NAME_MERGE_TAG_FIELD,
    LAST_NAME_MERGE_TAG_FIELD,
    COMPANY_NAME_MERGE_TAG_FIELD,
];
